import * as React from 'react';

import { makeTestId } from '../../utils/Declarative';
import { SliderBaseProps, SliderBaseWidget } from './SliderBaseWidget';

/**
 * A number range, inclusive. Used for the value and the trackBarDataRange.
 */
export interface SliderRange {
  /** The start value of the range, inclusive. */
  from: number;

  /** The end value of the range, inclusive. */
  to: number;
}

export interface RangeSliderProps extends Pick<
  SliderBaseProps,
  'ariaLabel' | 'ariaAttributes' | 'disabled' | 'max' | 'min' | 'onHandleRelease' | 'style' | 'testId' | 'trackBarDataRange'
  > {
  /**
   * When the slider is updated, this is called with the new SliderRange value.
   * NOTE: The consumer will need to update the 'value' prop passed to the slider for it to be visually updated.
   */
  onChange?: (value: SliderRange) => void;

  /**
   * The current value of the slider. It should be within the range of [min, max] and with 'from' being less
   * than (or equal to) 'to'.
   */
  value: SliderRange;
}

/**
 * This slider has two handles and lets a user select a range of values between those two handles.
 * It allows the user to choose any number from min to max, including decimal numbers.
 */
export function RangeSliderWidget(props: RangeSliderProps): JSX.Element {
  return <SliderBaseWidget {...props} testId={makeTestId(props.testId, 'RangeSlider')} />;
}
